var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2761 0.390525C17.7554 -0.130175 16.9112 -0.130175 16.3905 0.390525L9.33333 7.44772L2.27614 0.390524C1.75544 -0.130175 0.911223 -0.130175 0.390525 0.390524C-0.130175 0.911223 -0.130175 1.75544 0.390525 2.27614L8.39052 10.2761C8.91122 10.7968 9.75544 10.7968 10.2761 10.2761L18.2761 2.27614C18.7968 1.75544 18.7968 0.911223 18.2761 0.390525Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.1d3bac569ae0ef99acbae57890eb917f.svg";
export { ForwardRef as ReactComponent };